module.exports = __webpack_public_path__ + "static/media/urdu.cbd82d5d.svg";